/**
 * 农药剂型
 */
export default [
  '原药', '颗粒剂', '悬浮剂', '水剂', '水乳剂', '乳油', '可溶液剂', '可湿性粉剂', '水分散粒剂'
]



// WEBPACK FOOTER //
// ./src/components/resource/inputs/medical-forms.js